import SearchForm from "../components/Form/SearchForm/SearchForm";
import "../media/styles/Home.css";
import React from "react";
import {ROOT_DIR} from "../App";
import HomeArticle from "../components/Home/HomeArticle";
import {Image} from "../components/Image/Image";
import DefaultHelmet from "../components/DefaultHelmet";
import ContactModalButton from "../components/Contact/ContactModalButton";
import SummerHolidays from "../components/Holidays/SummerHolidays";

function Home() {
    window.history.replaceState({}, document.title, "/");

    return (
        <div className="h-full">
            <DefaultHelmet/>
            <div className="relative h-full">
                <Image draggable="false" unselectable="on" className="h-screen w-full object-none md:object-fill"
                       src={ROOT_DIR + "/images/home/agence-immobiliere-monthey.jpg"}
                       alt="Agence immobilière FOTI Immobilier"/>
                <div className="absolute top-48 md:pt-12 left-0 md:top-96 md:left-48 w-full md:w-4/5">
                    <div className="flex justify-center md:justify-start">
                        <h1 className="text-white uppercase home-title font-bold text-3xl md:text-5xl w-5/6 mb-4">
                            Votre Agence Immobilière de Confiance à Monthey et Vevey
                        </h1>
                    </div>
                    <div className="flex md:block justify-center">
                        <SearchForm params={{actionType: "Acheter"}} />
                    </div>
                </div>
                <div className="py-10">
                    <SummerHolidays />
                    <div className="container mx-auto w-11/12 md:w-4/5 color-primary">
                        <section id="agence-presentation">
                            <h2 className="text-2xl md:text-5xl text-primary font-semibold mb-4">
                                FOTI Immobilier : Votre Partenaire Immobilier de Confiance sur la Riviera Vaudoise et
                                dans les Chablais Vaudois & Valaisan
                            </h2>
                            <p className="text-md md:text-xl mb-6">
                                Bienvenue chez FOTI Immobilier, votre agence de référence pour tous vos projets
                                immobiliers à Monthey et Vevey. Forts de notre expertise du marché local, nous vous
                                accompagnons dans la vente, l'achat et la location de biens résidentiels et
                                commerciaux.
                            </p>
                            <div className="mt-6 flex flex-col justify-center gap-y-6 md:gap-y-10">
                                <HomeArticle title="Immobilier à Monthey"
                                             description="Découvrez notre sélection d'appartements, de maisons, de terrains et de locaux commerciaux disponibles à Monthey. Profitez du cadre de vie agréable et des nombreuses opportunités qu'offre cette région dynamique."
                                             city="Monthey"
                                             postalCode="1870"
                                             position="right"
                                             cityDescription="Monthey, située au cœur du Chablais valaisan, offre un marché immobilier diversifié, allant des appartements modernes aux chalets traditionnels. Sa proximité avec les stations de ski et son dynamisme économique en font un lieu de vie attractif pour les familles et les professionnels. Notre agence vous propose une sélection rigoureuse de biens à la vente et à la location à Monthey et ses environs."
                                />
                                <article className="text-md md:text-xl">
                                    Forte d'une solide expérience du marché immobilier local, FOTI Immobilier est votre
                                    partenaire de confiance à Monthey et Vevey. Notre équipe d'experts vous accompagne
                                    dans tous vos projets : vente, achat, location, gestion locative et estimation de
                                    biens. Nous mettons à votre service notre connaissance approfondie de ces deux
                                    régions pour vous offrir un service personnalisé et efficace.
                                </article>
                                <HomeArticle title="Immobilier à Vevey"
                                             description="Explorez nos offres de biens immobiliers à Vevey, ville charmante au bord du lac Léman. Que vous recherchiez un appartement avec vue, une villa familiale ou un espace commercial, notre équipe est là pour vous conseiller."
                                             city="Vevey"
                                             postalCode="1800"
                                             position="left"
                                             cityDescription="Ville emblématique de la Riviera vaudoise, Vevey séduit par son cadre de vie exceptionnel au bord du lac Léman et sa richesse culturelle. Que vous recherchiez un appartement avec vue sur le lac, une villa dans les hauteurs ou un bien de prestige, notre équipe à Vevey est à votre écoute pour concrétiser votre projet immobilier."
                                />
                                <article className="text-md md:text-xl">
                                    Choisir FOTI Immobilier pour votre projet à Monthey et Vevey, c'est bénéficier d'une
                                    expertise unique sur deux marchés dynamiques. Notre équipe vous offre un
                                    accompagnement personnalisé, de la recherche du bien idéal à la signature de l'acte.
                                    Grâce à notre réseau étendu et nos outils innovants, nous simplifions votre parcours
                                    immobilier.
                                </article>
                            </div>
                            <div className="flex flex-col items-center mt-6 gap-y-6">
                                <p className="text-3xl font-semibold">
                                    Vous avez un projet immobilier à Monthey ou Vevey ?
                                </p>
                                <ContactModalButton isCTA={true} text="Contactez-nous dès maintenant !"/>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
